export enum AuthRoutes {
	SignIn = '/auth/sign-in',
	SignInConsumer = '/auth/customer-sign-in',
	SignUp = '/auth/sign-up',
	SignUpConsumer = '/auth/customer-sign-up',
	ConfirmUser = '/auth/confirm-user',
	ConfirmInvite = '/auth/confirm-invite',
	ConfirmPassword = '/auth/confirm-password',
	ResendConfirmationCode = '/auth/resend-confirmation-code',
	ForgotPassword = '/auth/forgot-password',
	SignOut = '/auth/sign-out',
}
